import {h, Fragment} from "preact"
import { useContext, useEffect, useState } from 'preact/hooks';
import { createContext } from "preact"

const SidebarContext = createContext(null);

export const useSidebarContext = () => {
    return useContext(SidebarContext);
}

export function SidebarProvider({ children }) {
    const [ sidebarOpen, setSidebarOpen ] = useState((window.innerWidth > 1023));

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)
    }

    const openSidebar = () => {
        setSidebarOpen(true);
    }

    const closeSidebar = () => {
        setSidebarOpen(false);
    }

    useEffect(() => {
        if(window.innerWidth > 1023) return;
        document.body.style.overflow = sidebarOpen ? "hidden" : "";
        return () => document.body.style.overflow = "";
    }, [ sidebarOpen ])

    useEffect(() => {
        const handleKeydown = (e) => {
            if(sidebarOpen && e.target.closest('.ns-serp') && (e.key === 'Escape' || e.key === 'Enter')) {
                setSidebarOpen(false);
            }
        }
        
        window.document.addEventListener('keydown', handleKeydown);
        return () => window.document.removeEventListener('keydown', handleKeydown);
    }, [ sidebarOpen ])

    return (
        <SidebarContext.Provider 
            value={{ 
                sidebarOpen, 
                openSidebar, 
                closeSidebar,
                toggleSidebar
            }} 
        >
            {children}
        </SidebarContext.Provider>
    )
}